<template>
  <div>
    <div class="text-right">
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            x-small
            elevation="0"
            @click="showWidgetConfig"
            v-on="on"
            height="12"
            width="12"
            ><v-icon x-small>fa-cog</v-icon></v-btn
          >
        </template>
        <span>{{ $t("common.main_widgets_settings") }}</span>
      </v-tooltip>
    </div>
    <v-progress-linear
      indeterminate
      color="primary"
      class="pl-1"
      v-if="isLoadingMainWidgetParameters || !isProcessedWidgetParams"
    ></v-progress-linear>
    <draggable
      v-if="isProcessedWidgetParams === true"
      :list="cards"
      @end="changePosition"
      class="row"
      handle=".handler"
    >
      <v-col
        v-for="card in cards.filter(
          (w) => w.isVisible && userHasRight(w.right)
        )"
        :key="card.title"
        :cols="flex"
      >
        <v-card elevation="0" height="272px" class="overflow-hidden">
          <v-row>
            <v-col class="px-0 py-0">
              <v-card-actions class="pt-1 d-flex pa-0 px-0 pl-5 pr-5 pb-2">
                <h3 class="pl-2 pt-3 handler" style="cursor: move">
                  {{ $t(card.title) }}
                </h3>
                <span class="text-caption" v-if="card.type === 'intervals'">
                  {{ date | moment("DD.MM.YYYY") }}
                </span>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      min-width="36"
                      min-height="36"
                      class="mb-0 mr-0 px-0 mt-1"
                      elevation="0"
                      ripple
                      @click="$router.push({ name: card.routeName })"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        small
                        color="primary"
                        @click="$router.push({ name: card.routeName })"
                        v-if="card.icon"
                        >{{ card.icon }}</v-icon
                      >
                    </v-btn>
                  </template>
                  {{ $t("home_widgets.go_to_section") }}: "{{ $t(card.title) }}"
                </v-tooltip>
              </v-card-actions>
              <v-divider></v-divider>
              <!--Заказы-->
              <v-card-text v-if="card.type === 'orders'" class="pt-1">
                <main-widget-orders :limit="parseInt(card.limit)" />
              </v-card-text>
              <!--Заказчики-->
              <v-card-text v-if="card.type === 'customers'" class="pt-1">
                <main-widget-customers :limit="parseInt(card.limit)" />
              </v-card-text>
              <!--Гараж-->
              <v-card-text v-if="card.type === 'garage'" class="pt-1">
                <main-widget-garage :limit="parseInt(card.limit)" />
              </v-card-text>
              <!--Заявки-->
              <v-card-text v-if="card.type === 'bids'" class="pt-1">
                <main-widget-bids :limit="parseInt(card.limit)" />
              </v-card-text>
              <!--календарь-->
              <v-card-text v-if="card.type === 'intervals'" class="pt-1">
                <main-widget-intervals />
              </v-card-text>
              <!--Звонки-->
              <v-card-text v-if="card.type === 'calls'" class="pt-1">
                <main-widget-calls :limit="parseInt(card.limit)" />
              </v-card-text>
              <!--Звонки-->
              <v-card-text v-if="card.type === 'calculations'" class="pt-1">
                <main-widget-calculations :limit="parseInt(card.limit)" />
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </draggable>
    <v-dialog
      v-model="widgetConfigWindow.isVisible"
      scrollable
      max-width="450"
      max-height="90%"
      min-width="90%"
    >
      <v-card>
        <v-card-actions>
          <h3 class="pl-2">
            {{ $t("common.main_widgets_settings") }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="widgetConfigWindow.isVisible = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-form ref="widgetsParametersForm">
            <v-list>
              <v-list-item
                v-for="widget in widgetConfigWindow.widgets.filter((w) =>
                  userHasRight(w.right)
                )"
              >
                <v-row>
                  <v-col class="flex-grow-0 flex-shrink-1"
                    ><v-checkbox v-model="widget.isVisible"></v-checkbox
                  ></v-col>
                  <v-col class="d-flex align-center">{{
                    $t(widget.title)
                  }}</v-col>
                  <v-col>
                    <v-text-field
                      v-model="widget.limit"
                      v-if="widget.limitable"
                      :label="$t('common.main_widgets_settings_num_of_records')"
                      :rules="[
                        (v) =>
                          !!v || $t('form.validationErrors.field_is_required'),
                        (v) =>
                          (!!v && parseFloat(v) > 0) ||
                          $t('form.validationErrors.must_be_greater', [0]),

                        (v) =>
                          (!!v && v && v == parseInt(v)) ||
                          $t('form.validationErrors.must_be_integer'),

                        (v) =>
                          (!!v && parseFloat(v) <= 50) ||
                          $t(
                            'form.validationErrors.must_be_less_than_or_equal_to',
                            [50]
                          ),
                      ]"
                      class="d-inline-flex"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-form>
          <v-divider></v-divider>
          <v-card-actions class="pa-0 mx-0 pt-5">
            <v-btn
              class="white--text"
              elevation="0"
              color="warning"
              @click="restore"
              :loading="isLoadingMainWidgetParameters"
              :disabled="isLoadingMainWidgetParameters"
            >
              {{ $t("common.restore_default") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="white--text"
              elevation="0"
              color="red"
              @click="widgetConfigWindow.isVisible = false"
              :loading="isLoadingMainWidgetParameters"
              :disabled="isLoadingMainWidgetParameters"
            >
              {{ $t("common.cancel") }}
            </v-btn>
            <v-btn
              color="primary"
              @click="saveWidgetParameters"
              @keyup.enter="saveWidgetParameters"
              elevation="0"
              :loading="isLoadingMainWidgetParameters"
              :disabled="isLoadingMainWidgetParameters"
            >
              {{ $t("common.save") }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RightsMixin from "@/mixins/rights";
import draggable from "vuedraggable";
import { mapFields } from "vuex-map-fields";
import MainWidgetOrders from "@/components/home/MainWidgetOrders.vue";
import MainWidgetCustomers from "@/components/home/MainWidgetCustomers.vue";
import MainWidgetGarage from "@/components/home/MainWidgetGarage.vue";
import MainWidgetBids from "@/components/home/MainWidgetBids.vue";
import MainWidgetIntervals from "@/components/home/MainWidgetIntervals.vue";
import MainWidgetCalls from "@/components/home/MainWidgetCalls.vue";
import CommonMixin from "@/mixins/common";
import MainWidgetCalculations from "@/components/home/MainWidgetCalculations.vue";

export default {
  name: "MainWidgets",
  mixins: [RightsMixin, CommonMixin],
  components: {
    MainWidgetCalculations,
    MainWidgetCalls,
    MainWidgetIntervals,
    MainWidgetBids,
    MainWidgetGarage,
    MainWidgetCustomers,
    MainWidgetOrders,
    draggable,
  },
  data: () => ({
    isProcessedWidgetParams: false,
    widgetConfigWindow: {
      isVisible: false,
      widgets: [],
    },
    widgets: [],
    widgetsPositions: [],
    widgetsDefault: [
      {
        id: 1,
        title: "common.customers",
        src: "https://cdn.vuetifyjs.com/images/cards/house.jpg",
        icon: "$customers",
        routeName: "customers",
        type: "customers",
        isVisible: true,
        limit: 5,
        limitable: true,
        right: "customers|view",
      },
      {
        id: 2,
        title: "navigation.garage",
        icon: "$garage",
        src: "https://cdn.vuetifyjs.com/images/cards/plane.jpg",
        routeName: "garage",
        type: "garage",
        isVisible: true,
        limit: 5,
        limitable: true,
        right: "garage|view",
      },
      {
        id: 3,
        title: "navigation.orders",
        src: "https://cdn.vuetifyjs.com/images/cards/foster.jpg",
        icon: "$cart",
        routeName: "orders",
        type: "orders",
        isVisible: true,
        limit: 5,
        limitable: true,
        right: "all_orders|view",
      },
      {
        id: 4,
        title: "navigation.bids",
        src: "https://cdn.vuetifyjs.com/images/cards/road.jpg",
        icon: "$bids",
        routeName: "bids",
        type: "bids",
        isVisible: true,
        limit: 5,
        limitable: true,
        right: "bids|view",
      },
      {
        id: 5,
        title: "navigation.calendar",
        src: "https://cdn.vuetifyjs.com/images/cards/road.jpg",
        icon: "$calendar",
        routeName: "intervals",
        type: "intervals",
        isVisible: true,
        limit: 5,
        limitable: false,
        right: "calendar|view",
      },
      {
        id: 6,
        title: "navigation.calls",
        icon: "$mobile_phone",
        routeName: "calls",
        type: "calls",
        isVisible: true,
        limit: 5,
        limitable: true,
        right: "calls|view",
      },
      {
        id: 7,
        title: "navigation.calculations",
        icon: "$calculator",
        routeName: "calculations",
        type: "calculations",
        isVisible: true,
        limit: 5,
        limitable: true,
        right: "calculations|view",
      },
    ],
    widgetsPositionsDefault: [
      {
        position: 0,
        widget_id: 1, //customers
      },
      {
        position: 1,
        widget_id: 2, //garage
      },
      {
        position: 2,
        widget_id: 3, //orders
      },
      {
        position: 3,
        widget_id: 4, //bids
      },
      {
        position: 4,
        widget_id: 5, //intervals
      },
      {
        position: 5,
        widget_id: 6, //calls
      },
      {
        position: 6,
        widget_id: 7, //calculations
      },
    ],
  }),
  mounted() {
    this.widgets = JSON.parse(JSON.stringify(this.widgetsDefault));
    this.widgetsPositions = JSON.parse(
      JSON.stringify(this.widgetsPositionsDefault)
    );
    this.getWidgetParameters();
  },
  computed: {
    ...mapFields("main_widget_parameters", [
      "mainWidgetParameters",
      "isLoadingMainWidgetParameters",
    ]),
    date() {
      let to = new Date();
      return to.toISOString().split("T")[0];
    },
    flex() {
      return this.$vuetify.breakpoint.smAndDown ? 12 : 4;
    },
    cards() {
      let result = [];
      for (let i = 0; i <= this.widgetsPositions.length; i++) {
        let position = this.widgetsPositions.find(
          (widgetPosition) => parseInt(widgetPosition.position) === i
        );

        if (position) {
          let widget = this.widgets.find(
            (widget) => widget.id === position.widget_id
          );
          if (widget) {
            result.push(widget);
          }
        }
      }
      return result;
    },
  },
  methods: {
    getWidgetParameters() {
      this.$store.dispatch("main_widget_parameters/get").then(() => {
        if (this.mainWidgetParameters.widgets) {
          this.widgets.forEach((item) => {
            this.mainWidgetParameters.widgets.forEach((itemFromApi) => {
              if (parseInt(itemFromApi.id) === parseInt(item.id)) {
                item.isVisible =
                  itemFromApi.isVisible && this.userHasRight(item.right);
                item.limit = parseInt(itemFromApi.limit);
              }
            });
          });
        }
        if (this.mainWidgetParameters.widgetsPositions) {
          this.widgetsPositions.forEach((position) => {
            this.mainWidgetParameters.widgetsPositions.forEach(
              (positionFromApi) => {
                if (
                  parseInt(position.widget_id) ===
                  parseInt(positionFromApi.widget_id)
                ) {
                  position.position = parseInt(positionFromApi.position);
                }
              }
            );
          });
        }
        this.isProcessedWidgetParams = true;
      });
    },
    store() {
      this.$store
        .dispatch("main_widget_parameters/store", {
          widgetsPositions: this.widgetsPositions,
          widgets: this.widgets.reduce((arr, item) => {
            arr.push({
              id: item.id,
              isVisible: item.isVisible,
              limit: item.limit,
            });
            return arr;
          }, []),
        })
        .then(() => {
          this.$store.dispatch("main_widget_parameters/get");
        });
    },
    restore() {
      this.$store.dispatch("main_widget_parameters/remove", {}).then(() => {
        this.widgetConfigWindow.isVisible = false;
        this.widgets = JSON.parse(JSON.stringify(this.widgetsDefault));
        this.widgetsPositions = JSON.parse(
          JSON.stringify(this.widgetsPositionsDefault)
        );
        this.$store.dispatch("main_widget_parameters/get");
      });
    },
    saveWidgetParameters() {
      if (this.$refs["widgetsParametersForm"].validate()) {
        this.widgets = JSON.parse(
          JSON.stringify(this.widgetConfigWindow.widgets)
        );
        this.store();
        this.widgetConfigWindow.isVisible = false;
      }
    },
    showWidgetConfig() {
      this.widgetConfigWindow.isVisible = true;
      this.widgetConfigWindow.widgets = JSON.parse(
        JSON.stringify(this.widgets)
      );
    },
    changePosition(event) {
      let oldIndex = event.oldIndex;
      let newIndex = event.newIndex;
      let visibleNum = 0;
      this.widgetsPositions.forEach((item) => {
        if (event.oldIndex === visibleNum) {
          oldIndex = item.position;
        }
        if (event.newIndex === visibleNum) {
          newIndex = item.position;
        }
        if (
          this.widgets.find(
            (w) =>
              w.isVisible &&
              w.id === item.widget_id &&
              this.userHasRight(w.right)
          )
        ) {
          visibleNum++;
        }
      });
      const movedWidgetPosition = this.widgetsPositions.find((position) => {
        return position.position === oldIndex;
      });
      const remainingWidgetsPositions = this.widgetsPositions.filter(
        (position) => position.position !== oldIndex
      );
      remainingWidgetsPositions.sort((a, b) => {
        if (a.position < b.position) return -1;
        if (a.position > b.position) return 1;
        return 0;
      });

      const reordered = [];
      for (let i = 0; i <= this.widgetsPositions.length; i++) {
        if (i === newIndex) {
          movedWidgetPosition.position = i;
          reordered.push(movedWidgetPosition);
        } else {
          let position = remainingWidgetsPositions.shift();
          if (position) {
            position.position = i;
            reordered.push(position);
          }
        }
      }
      this.widgetsPositions = reordered;
      this.store();
    },
  },
};
</script>

<style scoped>
.sortable-chosen {
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
  display: block;
}
</style>
